
export default function formattedTime(name) {

    let date = new Date(name)

    let hours = date.getHours()
    if (hours < 10) { hours = '0' + hours }

    let minutes = date.getMinutes()
    if (minutes < 10) { minutes = '0' + minutes }

    let seconds = date.getSeconds()
    if (seconds < 10) { seconds = '0' + seconds }

    let formatted_time = hours + ":" + minutes + ":" + seconds

    return formatted_time

}

